import { SessionSettingsDialog } from '@/components/SessionSettings/SessionSettingsDialog'
import { forwardRef } from 'react'
import { TopBar } from './TopBar'
import { cn } from '@/utlis/cn'
import OSXTitleBar from '@/components/OSXTitleBar'

type PageLayoutProps = {
    children?: React.ReactNode
    rightContent?: React.ReactNode
}
export const PageLayout = forwardRef<HTMLDivElement, PageLayoutProps>((props, ref) => {
    const layoutPadding = 'py-2 md:py-4 xl:py-6 px-2 md:px-12 lg:px-[120px]'
    const gridLayout = [
        'grid',
        'grid-cols-1 gap-0',
        'md:grid-cols-[calc(72%-10px)_calc(25%-10px)] md:gap-[calc(3%+20px)]',
        'lg:grid-cols-[calc(65%-20px)_calc(35%-20px)] lg:gap-[40px]',
        'xl:grid-cols-[calc(60%-30px)_calc(40%-30px)] xl:gap-[60px]',
    ]

    return (
        <div className={cn('w-full h-full')}>
            <OSXTitleBar />
            <div className="w-full h-full flex justify-center overflow-y-auto md:scrollbar-stable">
                <SessionSettingsDialog inSession={false} forceBrowserModal={true} />
                <div className={cn('flex flex-col w-full max-w-[1240px]', layoutPadding)}>
                    <TopBar className="pb-[20px] lg:pb-[40px]" />
                    <div className={cn(gridLayout, 'pb-[40px]')}>
                        <div className="w-full overflow-x-hidden" ref={ref}>
                            {props.children}
                        </div>
                        <div className={cn('w-full h-full flex justify-center')}>
                            <div className="w-full h-full max-w-[220px] flex flex-col gap-2 md:gap-5 py-2 md:py-[70px]">
                                {props.rightContent}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})
